import { CssValue, SelectorObj } from '../../shared.types'
import { DomApplier } from '../cssFeatures.types'
import { getVariantSelectors, variantsComparator } from '../../utils/variantsUtils'
import { fromClassicCss } from '../../utils/fromClassicCss'
import { CompVariantsViewItem } from '@wix/thunderbolt-catharsis'
import { CssContext } from '../componentCss.types'
import { generateCss } from '@wix/thunderbolt-becky-root'

export const stylableCssVariantsDomApplier = (
	cssInBreakpoint: { [variantsKey: string]: string | undefined },
	themeVariants: CompVariantsViewItem | null,
	compId: string,
	accumulatedData: CssContext
) =>
	Object.entries(cssInBreakpoint)
		.filter(([___, cssStylableString]) => !!cssStylableString)
		.sort(variantsComparator(themeVariants || {}))
		.reduce<SelectorObj>((acc, [variantKey, cssStylableString]) => {
			// Get the selector for the variant
			const domSelector = getVariantSelectors(variantKey as string, themeVariants, compId, {
				...accumulatedData,
				isStylable: true,
			}).join(',')

			// Get the css string and wrap it with the selector
			const classWrapCssConverted = { [domSelector]: generateCss(`${domSelector} {${cssStylableString}}`) }

			return Object.assign(acc || {}, classWrapCssConverted)
		}, {})

export const stylableCssDomApplier: DomApplier<'stylableCss'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ stylableCss, themeVariants },
	accumulatedData
) => {
	if (!stylableCss) {
		return null
	}

	if (stylableCss.type === 'classic') {
		return fromClassicCss((stylableCss.css as unknown) as CssValue, idSelector)
	}

	const cssInBreakpoint = stylableCss.css?.[breakpointId]
	return cssInBreakpoint
		? stylableCssVariantsDomApplier(cssInBreakpoint, themeVariants, compId, accumulatedData)
		: null
}
